import { connect } from "react-redux";
import selectors from "ui/molecule/footer/selectors";
import FooterUI from "ui/molecule/footer/FooterUI";

// alebo takto temu mame v props export default withStyles(customStyles, { withTheme: true })(AddBabySitterUI);
export default connect(selectors)(FooterUI);
